export const literals = {
  'login' : {
    'el': 'Σύνδεση',
    'en': 'Login'
  },
  'required': {
    'el': 'Υποχρεωτικό',
    'en': 'Required'
  },
  'invalidEmail': {
    'el': 'Λάθος διέυθυνση email',
    'en': 'Invalid email address'
  },
  'passwordsMissmatch': {
    'el': 'Οι κωδικοί δεν ταιριάζουν',
    'en': 'Passwords Don\'t Match'
  },
  'email' : {
    'el': 'Διεύθυνση Ηλ. Ταχυδρομείου',
    'en': 'email'
  },
  'password' : {
    'el': 'Κωδικός Πρόσβασης',
    'en': 'Password'
  },
  'verifyPassword': {
    'el': 'Επαλήθευση κωδικού',
    'en': 'Verify Password'
  },
  'submit' : {
    'el': 'Υποβολή',
    'en': 'Submit'
  },
  'register' : {
    'el': 'Εγγραφή',
    'en': 'Register'
  },
  'fullname': {
    'el': 'Όνομα ιδιώτη ή επιχείρησης',
    'en': 'Individual or Business Name'
  },
  'loginLoadingMessage' : {
    'el': 'Περιμένετε όσο σας συνδέουμε...',
    'en': 'Logging you in...'
  },
  'registrationLoadingMessage' : {
    'el': 'Υποβολή Αίτησης...',
    'en': 'Submiting...'
  },
  'deleteWarningMessage': {
    'el': 'Είστε σίγουρος για την διαγραφή;',
    'en': 'Are you sure you want to delete?'
  },
  'deleteSuccessMessage': {
    'el': 'Επιτυχής Διαγραφή',
    'en': 'Deleted Successfully'
  },
  'createSuccessMessage': {
    'el': 'Επιτυχής Δημιουργία',
    'en': 'Created Successfully'
  },
  'updateSuccessMessage' : {
    'el': 'Οι αλλαγές ενημερώθηκαν',
    'en': 'Preferences updated'
  },
  'loadingMessage' : {
    'el': 'Φόρτωση..',
    'en': 'Loading...'
  },
  'noProductsMessage': {
    'el': 'Δεν επιλέχθηκαν προιόντα για αυτήν την ιστοσελίδα',
    'en': 'No products selected for this website'
  },
  'addNew' : {
    'el': 'Προσθήκη Νέου',
    'en': 'Add new'
  },
  'name' : {
    'el': 'Όνομα',
    'en': 'Name'
  },
  'domainName' : {
    'el': 'Όνομα Domain',
    'en': 'Domain Name'
  },
  'actions' : {
    'el': 'Ενέργειες',
    'en': 'Actions'
  },
  'editClient' : {
    'el': 'Επεξεργασία',
    'en': 'Edit'
  },
  'clientsList' : {
    'el': 'Οι ιστοσελίδες μου',
    'en': 'My Domains'
  },
  'clientDomainHint' : {
    'el': 'Καταχωρήστε το domain name της ιστοσελίδας σας όπως αυτό εμφανίζεται κάνοντας το copy από την μπάρα του φυλλομετρητή σας (browser).',
    'en': 'Please submit your website`s domain name as it appears after copying it from your browser’s web address bar.'
  },
  'showProducts' : {
    'el': 'Δείτε τα Προιόντα',
    'en': 'Show Products'
  },
  'logout' : {
    'el': 'Αποσύνδεση',
    'en': 'Logout'
  },
  'clientInfo' : {
    'el': 'Στοιχεία Ιστότοπου',
    'en': 'Website Info'
  },
  'language' : {
    'el': 'Γλώσσα',
    'en': 'Language'
  },
  'delete' : {
    'el': 'Διαγραφή',
    'en': 'Delete'
  },
  'options' : {
    'el': 'Ρυθμίσεις',
    'en': 'Options'
  },
  'competitions' : {
    'el': 'Διοργανώσεις',
    'en': 'Competitions'
  },
  'availableCompetitions' : {
    'el': 'Διαθέσιμες Διοργανώσεις',
    'en': 'Available Competitions'
  },
  'selectedCompetitions' : {
    'el': 'Επιλεγμένες Διοργανώσεις',
    'en': 'Selected Competitions'
  },
  'style' : {
    'el': 'Επιλογές Εμφάνισης',
    'en': 'Style'
  },
  'resetToDefaults' : {
    'el': 'Επαναφορά Προεπιλογών Εμφάνισης',
    'en': 'Reset Style to Defaults'
  },
  'previewLayout' : {
    'el': 'Προεπισκόπιση',
    'en': 'Preview Layout'
  },
  'generateCodeMessage' : {
    'el': 'Αντιγράψτε και επικολλήστε τον παρακάτω κώδικα στην σελίδα σας για να αποκτήσετε το app',
    'en': 'Copy and Paste the following code to your website to get the app'
  },
  'color': {
    'el': 'Χρώμα',
    'en': 'Color'
  },
  'textColor': {
    'el': 'Χρώμα κειμένου',
    'en': 'Text Color'
  },
  'bgColor': {
    'el': 'Χρώμα παρασκηνίου',
    'en': 'Background Color'
  },
  'lineHeight': {
    'el': 'Ύψος Γραμμής: ',
    'en': 'Line Height :'
  },
  'fontFamily': {
    'el': 'Γραματοσειρά: ',
    'en': 'Font Family: '
  },
  'sizeScale': {
    'el': 'Μέγεθος: ',
    'en': 'Size Scale: '
  },
  'headerBgColor': {
    'el': 'Χρώμα παρασκηνίου κεφαλίδας:',
    'en': 'Header Background Color:',
  },
  'headerMainColor': {
    'el': 'Χρώμα τίτλου:',
    'en': 'Header Main Color:',
  },
  'headerSecondaryColor': {
    'el': 'Χρώμα Υπότιτλου:',
    'en': 'Header Secondary Color:',
  },
  'columnTitleColor': {
    'el': 'Χρώμα τίτλων στηλών:',
    'en': 'Column Titles Color:',
  },
  'columnTitleBgColor': {
    'el': 'Χρώμα παρασκηνίου τίτλων στηλών:',
    'en': 'Column Titles Background Color:',
  },
  'columnTitleVerticalBorderColor': {
    'el': 'Χρώμα κάθετου περιγράμματος τίτλων στηλών:',
    'en': 'Column Titles vertical border color:',
  },
  'columnTitleHorizontalBorderColor': {
    'el': 'Χρώμα οριζόντιου περιγράμματος τίτλων στηλών:',
    'en': 'Column Titles horizontal border color:',
  },
  'tableCellColor': {
    'el': 'Χρώμα κειμένου κελιών πίνακα:',
    'en': 'Table Cell text color:',
  },
  'tableCellVerticalBorderColor': {
    'el': 'Χρώμα κάθετου περιγράμματος κελιών πίνακα:',
    'en': 'Table Cell vertical border color:',
  },
  'tableCellHorizontalBorderColor': {
    'el': 'Χρώμα οριζόντιου περιγράμματος κελιών πίνακα:',
    'en': 'Table Cell horizontal border color:',
  },
  'updatePreferences' : {
    'el': 'Ενημέρωση Προτιμήσεων',
    'en': 'Update Preferences'
  },
  'copy': {
    'el': 'Αντιγραφη',
    'en': 'Copy'
  },
  'copySuccessMessage': {
    'el': 'Αντιγράφηκε επιτυχώς ',
    'en': 'Successfuly copied to clipboard '
  },
  'standingsShowCodeMessage': {
    'el': 'Πρέπει να θέσετε μια διοργάνωση ως προεπιλεγμένη για να εμφανιστεί ο κώδικας',
    'en': 'You need to set a default competition in order to reveal the code'
  }
  
}


// WEBPACK FOOTER //
// ./src/languages.js